module.exports = __webpack_public_path__ + "static/media/stack.790ad166.PNG";